import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'









function Product() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(58);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [products, setProducts] = useState([])
    const navigate = useNavigate()

    const productsCollectionRef = collection(db, "PRODUCTS");
    useEffect(() => {

        const getProducts = async () => {
            const data = await getDocs(productsCollectionRef);
            setProducts(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getProducts()
    }, [])
    return (

        <>

            <div className="album py-0">

                <div className="container">

                    <div className="row">
                        {products.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.title.toLowerCase().includes(searchTerm.toLowerCase())




                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((thelovebirdsicecream) => {
                            return (
                                <div className="col-md-3 mt-3">
                                    <div className='hoverimage1'>
                                        <div className='radios'>
                                        <img className="card-img-top image2" src={thelovebirdsicecream.img} alt={thelovebirdsicecream.title} />
                                        </div>
                                        <div className="overlay1 mb-2"> {thelovebirdsicecream.title}</div>
                                    </div>
                                    <div className="card-body">
                                        <center>
                                        <h4 className="mb-1 mt-2"> {thelovebirdsicecream.title}</h4>
                                            <p>{thelovebirdsicecream.des}</p>
                                        </center>
                                        <div className="d-flex justify-content-between align-items-center">
                                        </div>
                                    </div>


                                </div>
                            )
                        })}
                    </div>


                </div>
            </div>

        </>

    );
}

export default Product;



